import React, { useState } from 'react';

import { AddIcon } from 'constants/icon.constants';
import { DataTableAction } from 'components/DataTable';
import { ENTITY_SOP } from 'constants/schemas';
import NewSopDialog from 'components/NewSopDialog';
import PropTypes from 'prop-types';
import { formatType } from 'utils/entity.utils';

function ActionAddSop(props) {
  const { initState } = props;
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <>
      <DataTableAction
        label={`New ${formatType(ENTITY_SOP, { template: initState?.is_template })}`}
        icon={<AddIcon />}
        onClick={() => setDialogOpen(true)}
      />
      <NewSopDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        initState={initState}
      />
    </>
  );
}

ActionAddSop.propTypes = {
  initState: PropTypes.object,
};

export default ActionAddSop;
